<template>
  <div class="services_container displayBlockClass" style="float: right;max-width: 50%;margin-top: 18px;">
    <!-- Slideshow container -->
    <div  class="slideshow-container">

      <!-- Full-width images with number and caption text -->
      <div class="servicesmySlides">
        <img alt="slide"  src="../assets/services_slide1.jpg" style="width:100%">
        <!--<div class="text">Caption Text</div>-->
      </div>
<!--
      <div class="servicesmySlides">
        <img alt="slide"  src="../assets/services_slide2.jpg" style="width:100%">
        &lt;!&ndash;<div class="text">Caption Two</div>&ndash;&gt;
      </div>
      <div class="servicesmySlides">
        <img alt="slide"  src="../assets/services_slide3.jpg" style="width:100%">
        &lt;!&ndash;<div class="text">Caption Two</div>&ndash;&gt;
      </div>
      <div class="servicesmySlides">
        <img alt="slide"  src="../assets/services_slide4.jpg" style="width:100%">
        &lt;!&ndash;<div class="text">Caption Two</div>&ndash;&gt;
      </div>-->
    </div>
    <br>

    <!-- The dots/circles -->
    <div class="dots" style="text-align:center">
    </div>
  </div>
</template>

<script>
  export default {
    name: "slideshow",
    data () {
      return {
        slideIndex : 1
      }
    },
    mounted: function(){
      this.servicesshowSlides(this.slideIndex);
      let _this = this;
      setInterval(function(){
        _this.servicesplusSlides(1);
      },5000);
    },
    methods: {
      servicesplusSlides:function (n) {
        this.servicesshowSlides(this.slideIndex += n);
      },
      servicescurrentSlide:function (n) {
        this.servicesshowSlides(this.slideIndex = n);
      },
      servicesshowSlides:function (n) {
        let i;
        let slides = document.getElementsByClassName("servicesmySlides");
        let dots = document.getElementsByClassName("servicesdot");
        if (n > slides.length) {this.slideIndex = 1}
        if (n < 1) {this.slideIndex = slides.length}
        for (i = 0; i < slides.length; i++) {
          slides[i].style.display = "none";
        }
        for (i = 0; i < dots.length; i++) {
          dots[i].className = dots[i].className.replace(" active", "");
        }
        slides[this.slideIndex-1].style.display = "block";
        //dots[this.slideIndex-1].className += " active";
      }
    }
  }
</script>

<style scoped>
  * {box-sizing:border-box}

  /* Slideshow container */
  .slideshow-container {
    max-width: 229px;
    position: relative;
    /*height: 180px;*/
    margin: auto;
  }

  /* Hide the images by default */
  .servicesmySlides {
    display: none;
  }

  /* Next & previous buttons */
  .prev, .next {
    cursor: pointer;
    position: absolute;
    top: 50%;
    width: auto;
    margin-top: -22px;
    padding: 16px;
    color: white;
    font-weight: bold;
    font-size: 18px;
    transition: 0.6s ease;
    border-radius: 0 3px 3px 0;
    user-select: none;
  }

  .prev{
    left: 0;
  }

  /* Position the "next button" to the right */
  .next {
    right: 0;
    border-radius: 3px 0 0 3px;
  }

  /* On hover, add a black background color with a little bit see-through */
  .prev:hover, .next:hover {
    background-color: rgba(0,0,0,0.8);
  }

  /* Caption text */
  .text {
    color: #f2f2f2;
    font-size: 15px;
    padding: 8px 12px;
    position: absolute;
    bottom: 8px;
    width: 100%;
    text-align: center;
  }

  /* Number text (1/3 etc) */
  .numbertext {
    color: #f2f2f2;
    font-size: 12px;
    padding: 8px 12px;
    position: absolute;
    top: 0;
  }

  /* The dots/bullets/indicators */
  .servicesdot {
    cursor: pointer;
    height: 10px;
    width: 10px;
    margin: 0 2px;
    background-color: #bbb;
    border-radius: 50%;
    display: inline-block;
    transition: background-color 0.6s ease;

  }

  .dots{
    margin-top: -19px;
  }

  .active, .servicesdot:hover {
    background-color: #717171;
  }


  /* Fading animation */
  .fade {
    -webkit-animation-name: fade;
    -webkit-animation-duration: 1.5s;
    animation-name: fade;
    animation-duration: 1.5s;
  }

  @-webkit-keyframes fade {
    from {opacity: .4}
    to {opacity: 1}
  }

  @keyframes fade {
    from {opacity: .4}
    to {opacity: 1}
  }

  @media only screen and (max-width: 992px) {

    .servicesdot{
      width: 7px;
      height: 7px;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/services_slideshow.vue